import type { Currency, Money } from "@/content/types";

export function formatMoney(value: Money): string {
  const symbol = value.currency === "CNY" ? "¥" : "$";
  return `${symbol}${(value.amountMinor / 100).toFixed(2)}`;
}

export function currencySymbol(currency: Currency): string {
  return currency === "CNY" ? "¥" : "$";
}

export function currencyLabel(currency: Currency): string {
  return currency === "CNY" ? "RMB" : "美元";
}
